<template>
    <div>
        <div class="wizardWrapper">
            <div class="checkout-wrap">
                <div class="pageLayout">
                    <div class="contentSection">
                        <div class="infoText">
                            <label>
                                About this digital service:
                            </label>
                            <div>
                                <p>It takes about 3 minutes to make an appointment.</p>
                                <p>Services at LTA's Customer Service Centre are strictly by appointment only. Make an
                                    appointment only if your transaction cannot be carried out online.</p>
                                <p>
                                    Appointments can only be made 2 working days or more in advance.
                                </p>
                                <p>
                                    Depending on your appointment type, you may be required to enter details such as
                                    your vehicle number and notice number.
                                </p>
                            </div>
                        </div>
                        <form autocomplete="off" @submit="onFormSubmit">
                            <div class="formConatiner">
                                <a class="headingText"
                                    @click="newAppointment.isShowContactDetails = !newAppointment.isShowContactDetails">
                                    <h5 class="m-0"> Enter Contact Details <span class="rightAlign"><i
                                                v-if="!newAppointment.isShowContactDetails"
                                                class="pi pi-chevron-down"></i> <i
                                                v-if="newAppointment.isShowContactDetails"
                                                class="pi pi-chevron-up"></i></span></h5>
                                </a>
                                <div class="formFields"
                                    v-bind:class="{ 'collapse': !newAppointment.isShowContactDetails }">
                                    <div class="paddingSection">
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-7">
                                                <label class="labelFormText">
                                                    Name<span class="requiredIcon">&#42;</span>
                                                </label>

                                                <InputText tabindex="1" v-model.trim="v$.newAppointment.name.$model"
                                                    placeholder="Enter Name"
                                                    :class="{ 'p-error': v$.newAppointment.name.$error }"
                                                    @blur="v$.newAppointment.name.$touch()"
                                                    @input="v$.newAppointment.name.$touch()" />

                                                <div class="error"
                                                    v-if="v$.newAppointment.name.$dirty && v$.newAppointment.name.required.$invalid">
                                                    Name is required
                                                </div>

                                                <div class="error"
                                                    v-if="v$.newAppointment.name.$dirty && v$.newAppointment.name.maxLength.$invalid">
                                                    Name must not exceed 20 characters
                                                </div>

                                                <div class="error"
                                                    v-if="v$.newAppointment.name.$dirty && v$.newAppointment.name.isValid.$invalid">
                                                    You have entered an invalid character. Only the following characters
                                                    are allowed: , ' @ /
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-5">
                                                <label class="labelFormText">
                                                    Mobile Number<span v-if="isPhoneNumber"
                                                        class="requiredIcon">&#42;</span>
                                                </label>

                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon">+65</span>
                                                    <InputText tabindex="2"
                                                        v-model.number="v$.newAppointment.phoneNumber.$model"
                                                        type="number" @keypress="allowOnlyDigits"
                                                        :class="{ 'p-error': v$.newAppointment.phoneNumber.$error }" />
                                                </div>

                                                <div class="error"
                                                    v-if="v$.newAppointment.phoneNumber.$dirty && v$.newAppointment.phoneNumber.maxLength.$invalid">
                                                    Mobile number must not exceed 8 digits</div>
                                                <div class="error"
                                                    v-if="v$.newAppointment.phoneNumber.$dirty && v$.newAppointment.phoneNumber.minLength.$invalid">
                                                    Mobile number must be of 8 digits</div>
                                                <div class="error"
                                                    v-if="v$.newAppointment.phoneNumber.$dirty && v$.newAppointment.phoneNumber.minValue.$invalid">
                                                    Mobile number is not valid</div>
                                                <div class="error"
                                                    v-if="v$.newAppointment.phoneNumber.$dirty && v$.newAppointment.phoneNumber.isValid.$invalid">
                                                    Mobile number should be start with 8 or 9</div>
                                            </div>
                                            <div class="p-col-12 p-md-7">
                                                <label class="labelFormText">
                                                    Email Address<span v-if="isEmail" class="requiredIcon">&#42;</span>
                                                </label>
                                                <InputText tabindex="3" type="email"
                                                    v-on:keyup.tab="newAppointment.isShowService = true"
                                                    placeholder="example@email.com"
                                                    v-model.trim="v$.newAppointment.email.$model"
                                                    v-bind:class="{ 'p-error': v$.newAppointment.email.$error }" />

                                                <div class="error text-left text-danger"
                                                    v-if="v$.newAppointment.email.$dirty && v$.newAppointment.email.email.$invalid">
                                                    Email is not valid</div>
                                                <div class="error"
                                                    v-if="v$.newAppointment.email.$dirty && v$.newAppointment.email.maxLength.$invalid">
                                                    Email must not exceed 320 characters</div>
                                            </div>
                                        </div>
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12">
                                                <div class="error"
                                                    v-if="(v$.newAppointment.phoneNumber.$dirty && v$.newAppointment.phoneNumber.required.$invalid) || (v$.newAppointment.email.$dirty && v$.newAppointment.email.required.$invalid)">
                                                    Enter either a mobile number and/or an email address for creating
                                                    appointment.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="formConatiner">
                                <a class="headingText"
                                    @click="newAppointment.isShowService = !newAppointment.isShowService">
                                    <h5 class="m-0"> Select Appointment Service <span class="rightAlign"><i
                                                v-if="!newAppointment.isShowService" class="pi pi-chevron-down"></i> <i
                                                v-if="newAppointment.isShowService" class="pi pi-chevron-up"></i></span>
                                    </h5>
                                </a>
                                <div class="formFields" v-bind:class="{ 'collapse': !newAppointment.isShowService }">
                                    <div class="paddingSection">
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-3">
                                                <label class="labelFormText">
                                                    The appointment is for your<span class="requiredIcon">&#42;</span>
                                                </label>
                                            </div>
                                            <div class="p-col-12 p-md-9">
                                                <div v-for="serviceType in serviceTypeList" class="serviceTypeTd">
                                                    <table class="serviceGroupsTable">
                                                        <tbody>
                                                            <tr>
                                                                <td width="20px">
                                                                    <RadioButton tabindex="4" :id="serviceType.id"
                                                                        name="serviceAppointmentType"
                                                                        :value="serviceType.id"
                                                                        v-model="newAppointment.serviceGroupId" />
                                                                </td>
                                                                <td>
                                                                    <label :for="serviceType.id"
                                                                        class="p-radiobutton-label">
                                                                        {{ serviceType.text }}
                                                                        <br v-if="serviceType.description" />
                                                                        <span v-if="serviceType.description"
                                                                            class="additionalInfo">({{
                                                                                serviceType.description }})</span>
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="error"
                                                    v-if="v$.newAppointment.serviceGroupId.$dirty && v$.newAppointment.serviceGroupId.required.$invalid">
                                                    Service Type is required</div>
                                            </div>
                                        </div>
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-7">
                                                <label class="labelFormText">
                                                    Service Category<span class="requiredIcon">&#42;</span>
                                                </label>
                                                <dropdown tabindex="5" :filter="true"
                                                    v-model="v$.newAppointment.categoryId.$model" :options="categories"
                                                    optionValue="id" optionLabel="text"
                                                    placeholder="Select Service Category"
                                                    v-bind:class="{ 'p-error': v$.newAppointment.categoryId.$error }">
                                                </dropdown>
                                                <div class="error"
                                                    v-if="v$.newAppointment.categoryId.$dirty && v$.newAppointment.categoryId.required.$invalid">
                                                    Service category is required</div>

                                            </div>
                                        </div>
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-7">
                                                <label class="labelFormText">
                                                    Service<span class="requiredIcon">&#42;</span>
                                                </label>
                                                <dropdown tabindex="6" :filter="true"
                                                    v-model="v$.newAppointment.serviceId.$model" :options="services"
                                                    optionValue="id" optionLabel="text" placeholder="Select Service"
                                                    v-bind:class="{ 'p-error': v$.newAppointment.serviceId.$error }">
                                                </dropdown>
                                                <div class="error"
                                                    v-if="v$.newAppointment.serviceId.$dirty && v$.newAppointment.serviceId.required.$invalid">
                                                    Service is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="newAppointment.preBookingMessage">
                                <p><b>{{ newAppointment.serviceName }}</b></p>
                                <div v-html="newAppointment.preBookingMessage" class="bookingMessageMargin"></div>
                            </div>
                            <div class="formConatiner" v-if="isShowValidation">
                                <a class="headingText"
                                    @click="newAppointment.isShowServiceDetails = !newAppointment.isShowServiceDetails">
                                    <h5 class="m-0"> Enter Details <span class="rightAlign"><i
                                                v-if="!newAppointment.isShowServiceDetails"
                                                class="pi pi-chevron-down"></i> <i
                                                v-if="newAppointment.isShowServiceDetails"
                                                class="pi pi-chevron-up"></i></span> </h5>
                                </a>
                                <div class="formFields"
                                    v-bind:class="{ 'collapse': !newAppointment.isShowServiceDetails }">
                                    <div class="paddingSection">
                                        <div v-if="isVehicalShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        Vehicle Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="7"
                                                        v-model.trim="v$.newAppointment.vehicleNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.vehicleNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.vehicleNumber.$dirty && v$.newAppointment.vehicleNumber.required.$invalid">
                                                        Vehicle number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.vehicleNumber.$dirty && v$.newAppointment.vehicleNumber.maxLength.$invalid">
                                                        Vehicle number must not exceed 12 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.vehicleNumber.$dirty && v$.newAppointment.vehicleNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isVacShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        VAC Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="8"
                                                        v-model.trim="v$.newAppointment.vacNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.vacNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.vacNumber.$dirty && v$.newAppointment.vacNumber.required.$invalid">
                                                        VAC number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.vacNumber.$dirty && v$.newAppointment.vacNumber.maxLength.$invalid">
                                                        VAC number must not exceed 20 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.vacNumber.$dirty && v$.newAppointment.vacNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isNoticeShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        Notice Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="9"
                                                        v-model.trim="v$.newAppointment.noticeNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.noticeNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.noticeNumber.$dirty && v$.newAppointment.noticeNumber.required.$invalid">
                                                        Notice number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.noticeNumber.$dirty && v$.newAppointment.noticeNumber.maxLength.$invalid">
                                                        Notice number must not exceed 20 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.noticeNumber.$dirty && v$.newAppointment.noticeNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isPARFShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        PARF Rebates Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="10"
                                                        v-model.trim="v$.newAppointment.parfNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.parfNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.parfNumber.$dirty && v$.newAppointment.parfNumber.required.$invalid">
                                                        PARF rebates number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.parfNumber.$dirty && v$.newAppointment.parfNumber.maxLength.$invalid">
                                                        PARF rebates number must not exceed 13 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.parfNumber.$dirty && v$.newAppointment.parfNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isCEORShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        COE Rebates Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="11"
                                                        v-model.trim="v$.newAppointment.coeNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.coeNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.coeNumber.$dirty && v$.newAppointment.coeNumber.required.$invalid">
                                                        COE rebates number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.coeNumber.$dirty && v$.newAppointment.coeNumber.maxLength.$invalid">
                                                        COE rebates number must not exceed 13 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.coeNumber.$dirty && v$.newAppointment.coeNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isTcoeShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        TCOE Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="12"
                                                        v-model.trim="v$.newAppointment.tcoeNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.tcoeNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.tcoeNumber.$dirty && v$.newAppointment.tcoeNumber.required.$invalid">
                                                        TCOE number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.tcoeNumber.$dirty && v$.newAppointment.tcoeNumber.maxLength.$invalid">
                                                        TCOE number must not exceed 17 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.tcoeNumber.$dirty && v$.newAppointment.tcoeNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="ishVParkShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        HV Park Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="13"
                                                        v-model.trim="v$.newAppointment.hvParkNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.hvParkNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.hvParkNumber.$dirty && v$.newAppointment.hvParkNumber.required.$invalid">
                                                        HV Park number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.hvParkNumber.$dirty && v$.newAppointment.hvParkNumber.maxLength.$invalid">
                                                        HV Park number must not exceed 13 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.hvParkNumber.$dirty && v$.newAppointment.hvParkNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isDeviceNumberShow" class="serviceFields">
                                            <div class="p-grid p-fluid">
                                                <div class="p-col-12 p-md-7">
                                                    <label class="labelFormText">
                                                        Device Number<span class="requiredIcon">&#42;</span>
                                                    </label>
                                                    <InputText tabindex="14"
                                                        v-model.trim="v$.newAppointment.deviceNumber.$model"
                                                        v-bind:class="{ 'p-error': v$.newAppointment.deviceNumber.$error }" />
                                                    <div class="error"
                                                        v-if="v$.newAppointment.deviceNumber.$dirty && v$.newAppointment.deviceNumber.required.$invalid">
                                                        Device number is required</div>
                                                    <div class="error"
                                                        v-if="v$.newAppointment.deviceNumber.$dirty && v$.newAppointment.deviceNumber.maxLength.$invalid">
                                                        Device number must not exceed 12 characters</div>
                                                    <div class="error text-left"
                                                        v-if="v$.newAppointment.deviceNumber.$dirty && v$.newAppointment.deviceNumber.isValid.$invalid">
                                                        You have entered an invalid character. <br /> Only the following
                                                        characters are allowed: , ' @ / - _ $ # ? . &
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formConatiner m-0">
                                <a class="headingText" @click="newAppointment.isShowNote = !newAppointment.isShowNote">
                                    <h5 class="m-0"> Notes to LTA <span class="rightAlign"><i
                                                v-if="!newAppointment.isShowNote" class="pi pi-chevron-down"></i> <i
                                                v-if="newAppointment.isShowNote" class="pi pi-chevron-up"></i></span>
                                    </h5>
                                </a>
                                <div class="formFields" v-if="newAppointment.isShowNote"
                                    v-bind:class="{ 'collapse': !newAppointment.isShowNote }">
                                    <div class="paddingSection">
                                        <div class="p-grid p-fluid">
                                            <div class="p-col-12 p-md-7">
                                                <label class="labelFormText">
                                                    What is the purpose of this appointment?
                                                </label>
                                                <Textarea tabindex="15" v-model.trim="v$.newAppointment.remarks.$model"
                                                    :autoResize="true" rows="1" cols="30"
                                                    v-bind:class="{ 'p-error': v$.newAppointment.remarks.$error }" />
                                                <div class="error"
                                                    v-if="v$.newAppointment.remarks.$dirty && v$.newAppointment.remarks.maxLength.$invalid">
                                                    Remarks must not exceed 300 characters</div>
                                                <div class="error text-left"
                                                    v-if="v$.newAppointment.remarks.$dirty && v$.newAppointment.remarks.isValid.$invalid">
                                                    You have entered an invalid character. <br /> Only the following
                                                    characters are allowed: , ' @ / - _ $ # ? . &
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="reCaptchaContainer">
                                <div class="error" v-if="showMessage">
                                    Failed to verify ReCaptcha.
                                </div>
                            </div>
                            <div class="buttonContainer marginTopButton">
                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="float-Left">
                                            <Button type="button" label="< Back" @click="onBackAction()"
                                                class="linkBtn customLinkCss" />
                                        </div>
                                        <div class="float-Right">
                                            <Button type="submit" tabindex="16" label="Next" @click="onNextAction()"
                                                class="btn p-button-raised " />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, watch, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import {
    required,
    requiredIf,
    maxLength,
    minLength,
    minValue,
    email,
    numeric
} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useApiService } from '@/utils/useApiService';
import { defineEmits } from 'vue'
import { useNotifications } from '@/utils/useNotifications';
const { notifyError, notifyInfoError } = useNotifications()
const emit = defineEmits(['nextClick'])
const { fetchWrapperForGet, fetchWrapperForPost, fetchWrapperForPut } = useApiService()

const router = useRouter();
const store = useStore();
const id = ref(null);
const showMessage = ref(false);
const showloder = ref(true);
const isClearValidation = ref(false);
const isShowError = ref(false);

const isVehicalShow = ref(false);
const isNoticeShow = ref(false);
const isVacShow = ref(false);
const isPARFShow = ref(false);
const isCEORShow = ref(false);
const isTcoeShow = ref(false);
const ishVParkShow = ref(false);
const isDeviceNumberShow = ref(false);
const isShowValidation = ref(false)
const serviceGroups = ref([]);
const categories = ref([]);
const services = ref([]);
const serviceTypeList = ref([]);

const newAppointment = reactive({
    name: "", phoneNumber: "", email: "",
    serviceGroupId: "", categoryId: "", serviceId: "",
    vehicleNumber: "", noticeNumber: "", vacNumber: "",
    parfNumber: "", coeNumber: "", tcoeNumber: "",
    hvParkNumber: "", remarks: "", preBookingMessage: "",
    serviceName: "", deviceNumber: "",
    isShowContactDetails: true,
    isShowService: false,
    isShowServiceDetails: false,
    isShowNote: false,
    isReCaptchaValidate: false,
    appointmentDate: ""
});

const appointmentStore = reactive({
    name: "", phoneNumber: "", email: "",
    serviceGroupId: "", categoryId: "", serviceId: "",
    vehicleNumber: "", noticeNumber: "", vacNumber: "",
    parfNumber: "", coeNumber: "", tcoeNumber: "",
    hvParkNumber: "", remarks: "",
    serviceName: "", preBookingMessage: "", deviceNumber: ""
});

const reCaptchaInfo = reactive({ token: "" });
const rules = () => ({
    newAppointment: {
        name: {
            required,
            maxLength: maxLength(20),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'\/]*)?$/.test(v) : true
        },
        phoneNumber: {
            numeric,
            maxLength: maxLength(8),
            minLength: minLength(8),
            minValue: minValue(1),
            required: requiredIf(() => !newAppointment.email),
            isValid: v => v ? /^[89]/.test(v) : true
        },
        email: {
            email,
            maxLength: maxLength(320),
            required: requiredIf(() => !newAppointment.phoneNumber)
        },
        serviceGroupId: { required },
        categoryId: { required },
        serviceId: { required },

        vehicleNumber: {
            required: requiredIf(() => isVehicalShow.value),
            maxLength: maxLength(12),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        noticeNumber: {
            required: requiredIf(() => isNoticeShow.value),
            maxLength: maxLength(20),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        vacNumber: {
            required: requiredIf(() => isVacShow.value),
            maxLength: maxLength(20),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        parfNumber: {
            required: requiredIf(() => isPARFShow.value),
            maxLength: maxLength(13),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        coeNumber: {
            required: requiredIf(() => isCEORShow.value),
            maxLength: maxLength(13),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        tcoeNumber: {
            required: requiredIf(() => isTcoeShow.value),
            maxLength: maxLength(17),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        hvParkNumber: {
            required: requiredIf(() => ishVParkShow.value),
            maxLength: maxLength(13),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        remarks: {
            maxLength: maxLength(300),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        },
        deviceNumber: {
            required: requiredIf(() => isDeviceNumberShow.value),
            maxLength: maxLength(12),
            isValid: v => v ? /^([a-zA-Z0-9 @,\u2018\u2019'#\-._$?&\/]*)?$/.test(v) : true
        }
    }
});

const v$ = useVuelidate(rules, { newAppointment });



function onBackAction() {
    store.dispatch('reset')
        .then(() => {
            router.push('/');
        });
}

function onFormSubmit(e) {
    e.preventDefault();

}

function validate(success) {
    reCaptchaInfo.token = success;
}

function getServiceGroups() {
    return fetchWrapperForGet('api/masters/servicegroups', false, false)
        .then(data => { if (data) serviceTypeList.value = data; });
}

function okFunction() {
    return fetchWrapperForGet('api/MopSessions/Delete', false, false, true)
        .then(() => {
            store.dispatch('reset').then(() => window.location.reload());
        });
}
let sessionMOP = ref()

async function executeRecaptcha(action) {
  if (!window.grecaptcha) throw new Error('grecaptcha not loaded');

  return await window.grecaptcha.execute(siteKey.value, { action });
}
async function onNextAction() {
    v$.value.$touch();

    if (isShowError.value) return false;

    if (v$.value.$invalid) {
        newAppointment.isShowContactDetails = true;
        newAppointment.isShowService = true;
        newAppointment.isShowServiceDetails = true;
        newAppointment.isShowNote = true;
        return false;
    }

    try {
        const token = await executeRecaptcha('contactDetails');
        reCaptchaInfo.token = token;

        const appointment = { ...newAppointment };
        appointment.preBookingMessage = '';
        appointment.reCaptcha = reCaptchaInfo;

        if (id.value) {
            try {
                await fetchWrapperForGet('api/HeartBeat', false, false, false);
                appointment.id = id.value;

                const response = await fetchWrapperForPut(
                    'api/mopSessions',
                    appointment,
                    false,
                    true,
                    true,
                    true
                );

                if (response || response === '') {
                    updateStore();
                    await store.dispatch('setNewAppointMent', newAppointment);
                    emit('nextClick');
                }
            } catch (err) {
                if (err?.errorCode === 422) {
                    notifyInfoError("Your session has expired due to inactivity. Please try again.", okFunction);
                } else {
                    notifyError(err);
                }
            }
        } else {
            const response = await fetchWrapperForPost(
                'api/mopSessions',
                appointment,
                false,
                true,
                true
            );

            if (!response) return;

            if (!response.isValid) {
                notifyInfoError(response.validationMassage);
                return;
            }

            await store.dispatch('setNewAppointMent', newAppointment);
            await store.dispatch('setAppointmentId', response.id);
            updateStore();
            emit('nextClick');
        }
    } catch (err) {
        console.error('ReCaptcha failed:', err);
        notifyError('Failed to validate ReCaptcha. Please try again.');
    }
}



function getServiceCategory(val) {
    return fetchWrapperForGet(`api/servicegroups/${val}/servicecategories`, false, false, showloder.value)
        .then(data => { if (data) categories.value = data; });
}

function getServices(val) {
    return fetchWrapperForGet(`api/servicecategories/${val}/service`, false, false, showloder.value)
        .then(data => {
            if (!data) return;
            services.value = data.filter(x => x.isServiceHoursConfigured && x.isServiceCounterConfigured);
            serviceDetails();
        });
}

function getValidation(val) {
    return fetchWrapperForGet(`api/mopsessions/${val}/validations`, false, false, true)
        .then(data => {
            if (data.validationRules.length > 0) {
                isShowValidation.value = true;
            }
            const rulesArr = data.validationRules || [];
            isNoticeShow.value = rulesArr.includes("EnterNoticeNumber") || rulesArr.includes("ValidateNoticeNumber");
            isPARFShow.value = rulesArr.includes("EnterPARFRebatesNumber") || rulesArr.includes("ValidatePARFRebatesNumber");
            isVehicalShow.value = rulesArr.includes("EnterVehicleNumber") || rulesArr.includes("ValidateVehicleNumber");
            isCEORShow.value = rulesArr.includes("EnterCOERebatesNumber") || rulesArr.includes("ValidateCOERebatesNumber");
            isTcoeShow.value = rulesArr.includes("EnterTCOENumber") || rulesArr.includes("ValidateTCOENumber");
            isVacShow.value = rulesArr.includes("EnterVACNumber") || rulesArr.includes("ValidateVACNumber");
            ishVParkShow.value = rulesArr.includes("EnterHVParkNumber") || rulesArr.includes("ValidateHVParkNumber");
            isDeviceNumberShow.value = rulesArr.includes("EnterDeviceNumber");
            isClearValidation.value = true;
            showloder.value = true;
        });
}

function updateStore() {
    Object.assign(appointmentStore, JSON.parse(JSON.stringify(newAppointment)));
    store.dispatch('setMopAppointmentDetails', appointmentStore);
}

function clearValidation() {
    ['vehicleNumber', 'noticeNumber', 'vacNumber', 'parfNumber', 'coeNumber', 'tcoeNumber', 'hvParkNumber', 'deviceNumber'].forEach(field => {
        newAppointment[field] = "";
        v$.value.newAppointment[field].$reset();
    });
    isVehicalShow.value = isNoticeShow.value = isVacShow.value = isPARFShow.value = isCEORShow.value = isTcoeShow.value = ishVParkShow.value = isDeviceNumberShow.value = false;
}

function serviceDetails() {
    if (services.value.length && newAppointment.serviceId) {
        const sel = services.value.find(x => x.id == newAppointment.serviceId);
        if (sel) {
            isShowValidation.value = false;
            newAppointment.serviceName = sel.text;
            newAppointment.preBookingMessage = sel.preBookingMessage;
            appointmentStore.serviceName = sel.text;
            appointmentStore.preBookingMessage = sel.preBookingMessage;
            newAppointment.isShowServiceDetails = newAppointment.isShowNote = true;
        }
    }
}

const onserviceGroupChange = computed(() => newAppointment.serviceGroupId);
const onServiceCategoryChange = computed(() => newAppointment.categoryId);
const onServiceChange = computed(() => newAppointment.serviceId);

watch(onserviceGroupChange, (val, oldVal) => {
    if (isClearValidation.value) {
        clearValidation();
        newAppointment.categoryId = "";
        v$.value.newAppointment.categoryId.$reset();
        newAppointment.serviceId = "";
        v$.value.newAppointment.serviceId.$reset();
    }
    if (val) {
        getServiceCategory(val);
        services.value = [];
    }
});

watch(onServiceCategoryChange, (val) => {
    if (isClearValidation.value) {
        clearValidation();
        newAppointment.serviceId = "";
        newAppointment.serviceName = "";
        newAppointment.preBookingMessage = "";
        v$.value.newAppointment.serviceId.$reset();
    }
    if (val) getServices(val);
});

watch(onServiceChange, (val) => {
    if (isClearValidation.value) clearValidation();
    if (val) {
        getValidation(val);
        serviceDetails();
    }
});
const siteKey = ref(null);

function injectRecaptchaScript(key) {
  if (document.getElementById('recaptcha-script')) return;
  const script = document.createElement('script');
  script.id = 'recaptcha-script';
  script.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

function loadGreCaptcha() {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
      return;
    }
    const interval = setInterval(() => {
      if (window.grecaptcha) {
        clearInterval(interval);
        resolve(window.grecaptcha);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(interval);
      reject(new Error('Failed to load grecaptcha'));
    }, 10000);
  });
}
async function initReCaptcha() {
    let key = localStorage.getItem('sitekey')
    if (!key) throw new Error('Site key missing');
    siteKey.value = key;
    injectRecaptchaScript(siteKey.value);
    await loadGreCaptcha();
}
onMounted(async () => {
    getServiceGroups();
    store.dispatch('reset');
    try {
        await initReCaptcha();
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) badge.style.display = 'block';
    } catch (err) {
        console.error('Failed to load ReCaptcha:', err);
    }
})

onBeforeUnmount(() => {
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) badge.style.display = 'none';
});
</script>


<style>
.captachContainer {
    margin: 10px 0 20px 0;
    float: left;
    width: 100%;
    border: none !important;
}

.requiredIcon {
    color: red;
    font-size: large;
    font-style: normal;
    margin: auto;
}

p.m-0 {
    margin: 7px 0;
}

h5.m-0 {
    margin: 3px 0;
}

.paddingSection {
    padding: 10px 0;
}

.serviceTypeTd {
    margin: 0 0 17px 0;
}

.additionalInfo {
    font-weight: normal;
    margin-left: 8px;
}

.serviceGroupsTable td {
    vertical-align: text-bottom;
}

.bookingMessageMargin {
    margin-bottom: 20px;
}

.bookingMessageMargin p {
    margin: 0;
}

.p-inputgroup {
    display: flex;
    align-items: center;
}

.p-inputgroup-addon {
    padding: 0.5rem 0.75rem;
    background-color: #f4f4f4;
    border: 1px solid #ccc;
    border-right: none;
    border-radius: 4px 0 0 4px;
    font-size: 0.875rem;
    color: #333;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.p-inputgroup>.p-inputtext {
    border-radius: 0 4px 4px 0;
    border-left: none;
}


.p-select-option:not(.p-select-option-selected):not(.p-disabled).p-focus {
    color: #333333 !important;
    background-color: #eaeaea !important;
}

.recaptcha-container {
    position: fixed;
    bottom: 20px;
    right: 30px;
    display: flex;
    align-items: center;
    width: 60px;
    height: 60px;
    background-color: white;
    border-radius: 4px;
    overflow: hidden;
    transition: width 0.4s ease;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    z-index: 9999;
}


.recaptcha-container:hover {
    width: 274px;
    /* expand to show content */
}
</style>